import { render, staticRenderFns } from "./InputSelect.vue?vue&type=template&id=1393a325&"
import script from "./InputSelect.vue?vue&type=script&lang=ts&"
export * from "./InputSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports